/**
 * VINYLPAC — single source of truth for site-wide contact info.
 * Change values here; footer.html (used site-wide) reads from this object.
 */
var VP_SITE = {
  company: 'VINYLPAC',
  addressLine: 'Saco, ME',
  phone: '207-272-8762',
  phoneHref: 'tel:2072728762',
  email: 'info@vinylpac.us',
  emailHref: 'mailto:info@vinylpac.us'
};
